// extracted by mini-css-extract-plugin
module.exports = {"tile":"HeroBannerTile_tile__3z-8g","link":"HeroBannerTile_link__1B-_x","photo":"HeroBannerTile_photo__M_Zdd","photoReady":"HeroBannerTile_photoReady__U4vrT"};